<template>
  <div id="languageTest">
    <div class="bottombox">
      <Header ref="header" />
    </div>
    <div class="banner">
      <img src="../../assets/LanguageTest/banner.png" />
    </div>
    <div class="main">
      <div
        class="flexible_col w1200"
        v-if="adaptiveList[156]"
        @click="submitAdaptive(adaptiveList[156][0])"
      >
        <img src="@/assets/LanguageTest/box1_1.png" alt="" class="btn" />
      </div>
      <div
        class="flexible_col flexible_col_1358 w1200" :style="{marginTop:adaptiveList[156]?'-20px':0}"
        v-if="adaptiveList[1358]"
        @click="submitAdaptive(adaptiveList[1358][0])"
      >
        <img src="@/assets/LanguageTest/box1_1.png" alt="" class="btn" />
      </div>
      <div
        v-for="(item, index) in Object.keys(adaptiveList)"
        :key="index"
        :class="['w1200 box box' + index,`box${item}`]"
      >
        <div class="flexible_col_other" v-if="[156,1358].indexOf(item-0) == -1">
          <h3 class="col_title">
            <em></em>{{ item == 2 ? "雅思全真模考" :(item==4?"GRE全真模考":"托福全真模考")  }}
          </h3>
          <ul class="clearfix">
            <li
              class="col_li"
              v-for="(item1, index1) in adaptiveList[item]"
              :key="index1"
              @click="submitAdaptive(item1)"
            >
              <strong>
                {{ item1.Title }}
                <span>立即测试</span>
              </strong>
              <div class="bj"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- yycg_tan end -->
  </div>
</template>

<script>
import Header from "../../components/header/Header.vue"; //公共头部
import { getRandom } from "@/common/utils";
import { setEncryption } from "@/api/common";
export default {
  name: "App",
  components: {
    // 将组件隐射为标签,登陆弹窗
    Header
  },
  metaInfo() {
    return {
      title: "免费测试-启德考培在线_出国考试在线培训_考培网校",
      meta: [
        {
          name: "keywords",
          content:
            "启德考培免费测试系统,备考史密斯测试系统,雅思免费测试,托福免费测试"
        },
        {
          name: "description",
          content:
            "启德考培在线,启德考培旗下官方网校.启德考培教师团队,讲授托福在线课程、雅思在线课程等出国考试在线课程."
        }
      ]
    };
  },
  data() {
    return {
      scroll: "",
      adaptiveList: {}
    };
  },
  computed: {},
  methods: {
    submitAdaptive(target) {
      // let {
      //   adaptiveType: target
      // } = this;
      if (!this.$cookies.isKey("token")) {
        this.$refs.header.Personalover();
        return;
      }
      if (!target.TestPaperId) this.$message.warning("请选择课程");
      if (!target.IsAdaptive) {
        this.formB.type = target.CourseType;
        this.submitB();
        return;
      }
      this.$utils.gatAllNavUrl({
        ...target,
        paperId: target.TestPaperId,
        restart: 3
      });
    },
    getAdaptiveList() {
      this.$http
        .get(
          "https://schoolapi.eiceducation.com.cn/api/AdaptiveTest?systemId=6",
          {
            headers: {
              token: this.$cookies.get("token")
            }
          }
        )
        .then(result => {
          if (result.data.code == 200) {
            let { results } = result.data;

            let obj = {};
            for (let item of results) {
              if (obj[item.CourseTypePid]) {
                obj[item.CourseTypePid] = [...obj[item.CourseTypePid], item];
              } else {
                obj[item.CourseTypePid] = [item];
              }
            }
            this.adaptiveList = obj;console.log("this.adaptiveList", this.adaptiveList);
          } else {
            this.$message.error(result.data.msg);
          }
        });
    }
  },
  created: function() {
    let that = this;
    this.tokenkey = that.$cookies.get("token");
    this.getAdaptiveList();
  }
};
</script>

<style scoped>
.bottombox {
  position: relative;
  z-index: 9;
}

#languageTest {
  background: #fbfbfb;
}

.banner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 420px;
  overflow: hidden;
}

.banner img {
  display: block;
  width: 1200px;
  height: 420px;
  background: #fff;
}

.main {
  margin: 0 auto;
}

.main .flexible_col {
  cursor: pointer;
  height: 220px;
  position: relative;
  margin: 0 auto;
  background: url(../../assets/LanguageTest/box1.png)  no-repeat;
  width: 1260px;
  background-size: 100% 100%;
}

.main .flexible_col .btn {
  width: 132px;
  height: 132px;
  position: absolute;
  top: 42px;
  right: 70px;
}
.main .flexible_col_1358 {
  background: url(../../assets/LanguageTest/box_1358.png) no-repeat;
  background-size: 100% 100%;
}
.main .box {
  padding-bottom: 30px;
}

.main .box .col_title {
  font-weight: 400;
  font-size: 24px;
  color: #333333;
  line-height: 26px;
  text-align: left;
  padding-left: 25px;
  position: relative;
  margin-bottom: 30px;
}

.main .box .col_title em {
  width: 5px;
  height: 26px;
  background: #ff0659;
  border-radius: 0px 0px 0px 0px;
  position: absolute;
  top: 3px;
  left: 0;
}

.main .box0 .col_li {
  display: flex;
  width: 225px;
  height: 140px;
  border-radius: 0px 0px 0px 0px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  background: url(../../assets/LanguageTest/box2_1.png) bottom right no-repeat
    #fff;
  background-size: 170px 100px;

  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 26px;
  padding: 30px;
}
.main .box0 .col_li span {
  display: block;
  width: 72px;
  height: 20px;
  opacity: 0;
  margin-top: 5px;
  font-weight: 400;
  font-size: 12px;
  color: #ff0659;
  line-height: 20px;
  text-indent: 5px;
  background: url(../../assets/LanguageTest/box2_2.png) 53px no-repeat #fff;
  background-size: 14px 14px;
  border-radius: 10px 10px 10px 10px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.main .box0 .col_li:hover span {
  opacity: 1;
}

.main .box0 .col_li:nth-child(4n) {
  margin-right: 0;
}

.main .box0 .col_li:hover {
  color: #ffffff;
  background: url(../../assets/LanguageTest/box2.png) bottom right no-repeat
    #ff0659;
  background-size: 170px 100px;
  box-shadow: 0px 4px 20px 0px rgba(255, 6, 89, 0.4);
}

.main .box1 .col_li {
  display: flex;
  align-items: center;
  width: 290px;
  height: 80px;
  border-radius: 0px 0px 0px 0px;
  float: left;
  margin-right: 20px;
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
  background: #fff;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 26px;
  padding: 30px;
  padding-right: 260px;
}

.main .box1 .col_li span {
  display: block;
  width: 72px;
  height: 20px;
  opacity: 0;
  margin-top: 5px;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
  line-height: 20px;
  text-indent: 5px;
  background: url(../../assets/LanguageTest/box3_2.png) 53px no-repeat #337cff;
  background-size: 14px 14px;
  border-radius: 10px 10px 10px 10px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.main .box1 .col_li:hover span {
  opacity: 1;
}

.main .box1 .col_li:nth-child(2n) {
  margin-right: 0;
}

.main .box1 .col_li:hover {
  box-shadow: 0px 4px 20px 0px rgba(6, 97, 255, 0.2);
}

.main .box1 .col_li .bj {
  position: absolute;
  top: 0;
  right: 0;
  width: 240px;
  height: 140px;
  background: url(../../assets/LanguageTest/box3_1.png) bottom right no-repeat
    #ffffff;
  background-size: 240px 100px;
  transition: all 0.25s ease-in;
  -moz-transition: all 0.25s ease-in;
  -webkit-transition: all 0.25s ease-in;
}

.main .box1 .col_li:hover .bj {
  background: url(../../assets/LanguageTest/box3.png) bottom right no-repeat
    #337cff;
  background-size: 240px 100px;
}



  .main .box4 .col_li {
    display: flex;
    align-items: center;
    width: 290px;
    height: 80px;
    border-radius: 0px 0px 0px 0px;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;
    position: relative;
    cursor: pointer;
    transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -webkit-transition: all 0.25s ease-in;
    background: #FFF;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    line-height: 26px;
    padding: 30px;
    padding-right: 260px;
  }

  .main .box4 .col_li span {
    display: block;
    width: 72px;
    height: 20px;
    opacity: 0;
    margin-top: 5px;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 20px;
    text-indent: 5px;
    background: url(../../assets/LanguageTest/box4_2.png) 53px no-repeat #878DFF;
    background-size: 14px 14px;
    border-radius: 10px 10px 10px 10px;
    transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -webkit-transition: all 0.25s ease-in;
  }

  .main .box4 .col_li:hover span {
    opacity: 1;
  }

  .main .box4 .col_li:nth-child(2n) {
    margin-right: 0;
  }

  .main .box4 .col_li:hover {
    box-shadow: 0px 4px 20px 0px rgba(135,141,255, 0.2);
  }

  .main .box4 .col_li .bj {
    position: absolute;
    top: 0;
    right: 0;
    width: 240px;
    height: 140px;
    background: url(../../assets/LanguageTest/box4_1.png) bottom right no-repeat rgba(135,141,255, 0.05);
    background-size: 240px 100px;
    transition: all 0.25s ease-in;
    -moz-transition: all 0.25s ease-in;
    -webkit-transition: all 0.25s ease-in;
  }

  .main .box4 .col_li:hover .bj {
    background: url(../../assets/LanguageTest/box4.png) bottom right no-repeat #878DFF;
    background-size: 240px 100px;
  }
</style>



// WEBPACK FOOTER //
// src/page2/languageTest/languageTest.vue